module.exports = {
  idaman: {
    OIDC_AUTHORITY: 'https://login.idaman.pertamina.com',
    OIDC_CLIENT_ID: 'ba860d9b9fc44a16ae9aebd09d305174',
    OIDC_CLIENT_SCR: 'b1895e21-b394-4839-8633-c97c29252a9c',
    OIDC_REDIRECT_URI: 'https://hydrofeprod.azurewebsites.net/signin-oidc',
    OIDC_LOGOUT_URI:
      'https://hydrofeprod.azurewebsites.net/signout-callback-oidc',
  },
  google: {
    API_KEY: '',
    CLIENT_ID: '',
    SECRET: '',
  },
  facebook: {
    APP_ID: '',
  },
  web: {
    WEB_URL: 'https://hydrofeprod.azurewebsites.net',
  },
  api: {
    API_URL: 'https://hydroapiprod.azurewebsites.net/api',
  },
  download: {
    DWL_URL:
      'https://hydroapiprod.azurewebsites.net/api/docs/supporting-documents/',
  },
  // `06.WebApi` (ProHydro) — master data: Fungsi, Klausa Category/Information,
  // Jenis Pengadaan, Crude Category, RefineryUnits (the reports' Plant lookup).
  proHydro: {
    API_URL:
      'https://hydroapicrudejoindev-dqedg3dca2h4enak.indonesiacentral-01.azurewebsites.net',
  },
  // `06.WebApi.Crude` — ChangeRequest approval workflow, CDU, Evaluation
  // Document, Reception Facility, Data Tracking, all four Reports.
  crude: {
    API_URL:
      'https://hydrowebapicrudejoindev-dddhftbycqfycyez.indonesiacentral-01.azurewebsites.net',
  },
  // Saklar halaman Pengumuman Tender publik. Data berasal dari api/public/tender-announcement.
  // true  = `/` menampilkan halaman Pengumuman Tender tanpa login.
  // false = seluruh landing publik mati; `/` kembali ke perilaku lama (ke /login).
  publicLanding: {
    ENABLED: true,
  },
};

module.hardcodeparam = {
  procurement: {
    PRODUCT_ID: '',
    PRODUCTYPE_PROPANE_ID: '',
    SECRET: '',
  },
};
